module.exports = __webpack_public_path__ + "static/fonts/Fact-ExpandedExtraLight.b0b57b5.ttf";